"use client";

import { usePathname } from 'next/navigation';
import FloatingYouTube from "@/components/FloatingYouTube";

// Map service slugs to YouTube video IDs
const serviceVideoMap: Record<string, string> = {
  'car-transport': 'CAR_VIDEO_ID',              // Replace with your car video ID
  'car-transport-service': 'CAR_VIDEO_ID',
  'bike-shifting': 'BIKE_VIDEO_ID',             // Replace with your bike video ID
  'bike-shifting-service': 'BIKE_VIDEO_ID',
  'packers-movers': 'HOUSEHOLD_VIDEO_ID',       // Replace with your household video ID
  'packers-and-movers-service': 'HOUSEHOLD_VIDEO_ID',
  'pet-relocation': 'PET_VIDEO_ID',             // Replace with your pet video ID
  'pet-relocation-service': 'PET_VIDEO_ID',
  'international-relocation': 'INTERNATIONAL_VIDEO_ID', // Replace with your international video ID
  'international-relocation-service': 'INTERNATIONAL_VIDEO_ID',
};

// Map exact page paths (for top-level service pages)
const exactPathMap: Record<string, string> = {
  '/': 'R0nW2UccekU', // Company main video
  '/car-transport': 'CAR_VIDEO_ID',
  '/bike-shifting': 'BIKE_VIDEO_ID',
  '/packers-movers': 'HOUSEHOLD_VIDEO_ID',
  '/pet-relocation': 'PET_VIDEO_ID',
  '/international-relocation': 'INTERNATIONAL_VIDEO_ID',
};

/**
 * Extract service slug from path based on patterns:
 * - /{city}/{service}-service          → service
 * - /{service}-service-from-{from}-to-{to}  → service
 * - /{city}/{service}-service-in-{locality} → service
 */
function extractServiceSlug(path: string): string | null {
  const segments = path.split('/').filter(Boolean);

  if (segments.length === 1) {
    // City page or home – return null (use main video)
    return null;
  }

  if (segments.length === 2) {
    // City + Service: /greater-noida/packers-and-movers-service
    const second = segments[1];
    if (second.includes('-service')) {
      return second;
    }
    return null;
  }

  if (segments.length >= 2) {
    // Check for service-from pattern
    const first = segments[0];
    if (first.includes('-service-from-')) {
      // Extract service part before '-service-from-'
      const servicePart = first.split('-service-from-')[0] + '-service';
      return servicePart;
    }

    // Check for service-in pattern (city + service + locality)
    if (segments.length >= 2) {
      const second = segments[1];
      if (second.includes('-service-in-')) {
        // Extract service part before '-service-in-'
        const servicePart = second.split('-service-in-')[0] + '-service';
        return servicePart;
      }
      if (second.includes('-service')) {
        return second;
      }
    }
  }

  return null;
}

export default function ClientWidgets() {
  const pathname = usePathname();

  let videoId = 'R0nW2UccekU'; // default main video

  if (pathname) {
    // 1. Check exact path match
    if (exactPathMap[pathname]) {
      videoId = exactPathMap[pathname];
    } else {
      // 2. Try to extract service slug from path
      const serviceSlug = extractServiceSlug(pathname);
      if (serviceSlug && serviceVideoMap[serviceSlug]) {
        videoId = serviceVideoMap[serviceSlug];
      }
    }
  }

  return <FloatingYouTube videoId={videoId} />;
}